import React from "react";

export interface FooterContextType {
  showFooter: boolean;
  setShowFooter: (_: boolean) => void;
}

export const FooterContext = React.createContext<FooterContextType>(null!);
